import { useState } from 'react';
import { useAuth } from '@tsuyosa/auth';
import type { AuthError } from '@tsuyosa/auth';

const TSUN_REGISTER_URL = import.meta.env.VITE_TSUN_REGISTER_URL ?? 'https://tsun.tsuyosa.id/register';

interface Props {
  onClose: () => void;
}

export function LoginModal({ onClose }: Props) {
  const { login } = useAuth();
  const [email, setEmail]         = useState('');
  const [password, setPassword]   = useState('');
  const [error, setError]         = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      onClose();
    } catch (err) {
      setError((err as AuthError).message ?? 'Login gagal');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-[#130d1a] p-6">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-semibold text-white">Login dengan akun Tsun</h2>
          <button onClick={onClose} className="text-white/40 transition hover:text-white/70">✕</button>
        </div>

        {error && (
          <p className="mb-4 rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-400">{error}</p>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="mb-1.5 block text-xs text-white/50">Email</label>
            <input
              type="email" required value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@contoh.com"
              className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2.5 text-sm text-white placeholder-white/30 focus:border-[#f472b6]/50 focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-xs text-white/50">Password</label>
            <input
              type="password" required value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2.5 text-sm text-white placeholder-white/30 focus:border-[#f472b6]/50 focus:outline-none"
            />
          </div>
          <button
            type="submit" disabled={isLoading}
            className="flex w-full items-center justify-center rounded-lg bg-[#f472b6] py-2.5 text-sm font-semibold text-white transition hover:bg-[#ec4899] disabled:opacity-50"
          >
            {isLoading
              ? <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
              : 'Login'
            }
          </button>
        </form>

        <p className="mt-4 text-center text-xs text-white/30">
          Belum punya akun?{' '}
          <a href={TSUN_REGISTER_URL} className="text-[#f472b6] hover:underline">
            Daftar di Tsun
          </a>
        </p>
      </div>
    </div>
  );
}
